import { FC, useRef } from 'react'

import { Flex, HStack, Square, Text } from '@chakra-ui/react'
import { BUTTON_FONT_SIZE, BUTTON_ICON_SIZE } from '@editor/config/constants'
import { Tooltip } from '@infraloop/common'
import { Link as RouterLink } from 'react-router'

const NavbarPageButton: FC<{
  /**
   * The ID of the button
   */
  id: string

  /**
   * The title of the button
   */
  title: string

  /**
   * Tooltip text
   */
  tooltip: React.ReactNode

  /**
   * The icon of the button
   */
  icon: React.ReactNode

  /**
   * The URL path to be navigated to
   */
  path: string

  /**
   * Whether the current page is the active page
   */
  isActive: boolean

  /**
   * Whether the button is disabled
   */
  isDisabled?: boolean
}> = ({ id, title, tooltip, icon, path, isActive, isDisabled }) => {
  const ref = useRef(null)

  return (
    <Flex ref={ref}>
      <Tooltip showArrow positioning={{ placement: 'bottom' }} label={tooltip} portalRef={ref}>
        <Square
          as={RouterLink}
          position="relative"
          color="white"
          opacity={isDisabled ? 0.35 : 1}
          fontSize={BUTTON_FONT_SIZE}
          minHeight={{ base: 12, xl: 10 }}
          maxHeight={{ base: 12, xl: 10 }}
          px={4}
          backgroundColor={isActive ? 'gray2.600' : 'transparent'}
          data-testid={id}
          asChild
        >
          <RouterLink to={isDisabled ? '#' : path}>
            <HStack gap={0} as="span">
              <Square as="span" fontSize={BUTTON_ICON_SIZE}>
                {icon}
              </Square>
              <Text as="span" whiteSpace="nowrap" className={['width-expand', isActive ? 'active' : ''].join(' ')}>
                {title}
              </Text>
            </HStack>
          </RouterLink>
        </Square>
      </Tooltip>
    </Flex>
  )
}

export default NavbarPageButton
